<template>
  <div id="headGiftCard">
    <div class="top-banner" data-aos="fade-up" data-aos-duration="900">
      <div class="image-gradient-bottom"></div>
      <div class="top-banner-content">
        <h1 :class="isPhone ? 'merriweather-reg-32' : 'merriweather-reg-40'">La carte cadeau Hortense</h1>
        <h2 class="merriweather-reg-18">Offrez à vos proches une évasion éco-chic</h2>
      </div>
      <div class="banner-flag-badge">
        <span class="flag-icon" v-html="getFranceFlag()"></span>
        <span class="flag-text">Entreprise française</span>
      </div>
      <div class="btn-banner" @click="goToPaymentPage">
        <div class="hortense-btn-primary raleway-semi-p13 text-uppercase">
          Offrir une carte cadeau
        </div>
      </div>
      <div class="btn-banner-phone" @click="goToPaymentPage">
        <div class="hortense-btn-primary raleway-semi-p13 text-uppercase">
          Offrir une carte cadeau
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "/node_modules/flag-icons/css/flag-icons.min.css";
import { data } from 'jquery';

  export default {
    name: 'headGiftCard',
    data() {
      return {
        isPhone: window.innerWidth <= 768,
      }
    },
    methods: {
      scrollToElement(div) {
        const el = document.getElementsByClassName(div)[0];

        if (el) {
          el.scrollIntoView();
        }
      },
      goToPaymentPage() {
        window.location.href = '/carte-cadeau/paiement';
      },
      getFranceFlag() {
        return '<span style="width: 20px; height: 13px;" class="fi fi-fr"></span>';
      }
    },
  }
</script>

<style lang="scss" scoped>
.top-banner {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-image: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/carte-cadeau-voyage-hortense.webp');
  background-size: cover;

  .top-banner-content {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
  }

  .image-gradient-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 115%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
    pointer-events: none;
  }

  .banner-flag-badge {
    position: absolute;
    bottom: 20px;
    left: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    z-index: 3;

    .flag-icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .flag-text {
      font-size: 14px;
      font-family: 'Raleway', sans-serif;
      font-weight: 600;
      color: white;
      white-space: nowrap;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }
  }

  .btn-banner {
    width: 100%;
    display: flex;
    justify-content: center;
    cursor: pointer;
    z-index: 2;
    margin-top: 14rem;
  }

  .btn-banner-phone {
    display: none;
    justify-content: center;
    cursor: pointer;
    z-index: 2;
  }
}

@media (max-width: 768px) {
  .top-banner {
    .banner-flag-badge {
      bottom: 15px;
      left: 15px;

      .flag-text {
        font-size: 12px;
      }
    }

    .btn-banner {
      display: none;
    }

    .btn-banner-phone {
      display: flex;
      margin-top: 14rem;
      white-space: nowrap;
    }
  }
}
</style>
